import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _47ca0f46 = () => interopDefault(import('../../../pages/events/index.vue' /* webpackChunkName: "pages/events/index" */))
const _46bc30d9 = () => interopDefault(import('../../../pages/logged-in/index.vue' /* webpackChunkName: "pages/logged-in/index" */))
const _65407a9c = () => interopDefault(import('../../../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _d1d87ef8 = () => interopDefault(import('../../../pages/magic-link.vue' /* webpackChunkName: "pages/magic-link" */))
const _787257f2 = () => interopDefault(import('../../../pages/magic-link/index.vue' /* webpackChunkName: "pages/magic-link/index" */))
const _b91ae128 = () => interopDefault(import('../../../pages/magic-link/invalid.vue' /* webpackChunkName: "pages/magic-link/invalid" */))
const _1a0a643c = () => interopDefault(import('../../../pages/missing-event/index.vue' /* webpackChunkName: "pages/missing-event/index" */))
const _00bc6924 = () => interopDefault(import('../../../pages/notifications.vue' /* webpackChunkName: "pages/notifications" */))
const _ef592d1c = () => interopDefault(import('../../../pages/profile/index.vue' /* webpackChunkName: "pages/profile/index" */))
const _2295ffd8 = () => interopDefault(import('../../../pages/events/new.vue' /* webpackChunkName: "pages/events/new" */))
const _dd055890 = () => interopDefault(import('../../../pages/profile/change-password.vue' /* webpackChunkName: "pages/profile/change-password" */))
const _ac63e0e8 = () => interopDefault(import('../../../pages/profile/create.vue' /* webpackChunkName: "pages/profile/create" */))
const _5cf3b4a6 = () => interopDefault(import('../../../pages/profile/notification-preferences.vue' /* webpackChunkName: "pages/profile/notification-preferences" */))
const _2376d1f2 = () => interopDefault(import('../../../pages/profile/request-access.vue' /* webpackChunkName: "pages/profile/request-access" */))
const _0547af50 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _350edf51 = () => interopDefault(import('../../../pages/events/admin/_uuid/index.vue' /* webpackChunkName: "pages/events/admin/_uuid/index" */))
const _a9725c18 = () => interopDefault(import('../../../pages/events/join/_uuid/index.vue' /* webpackChunkName: "pages/events/join/_uuid/index" */))
const _3a40ace8 = () => interopDefault(import('../../../pages/events/_slug/_uuid/index.vue' /* webpackChunkName: "pages/events/_slug/_uuid/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/events",
    component: _47ca0f46,
    name: "events"
  }, {
    path: "/logged-in",
    component: _46bc30d9,
    name: "logged-in"
  }, {
    path: "/login",
    component: _65407a9c,
    name: "login"
  }, {
    path: "/magic-link",
    component: _d1d87ef8,
    children: [{
      path: "",
      component: _787257f2,
      name: "magic-link"
    }, {
      path: "invalid",
      component: _b91ae128,
      name: "magic-link-invalid"
    }]
  }, {
    path: "/missing-event",
    component: _1a0a643c,
    name: "missing-event"
  }, {
    path: "/notifications",
    component: _00bc6924,
    name: "notifications"
  }, {
    path: "/profile",
    component: _ef592d1c,
    name: "profile"
  }, {
    path: "/events/new",
    component: _2295ffd8,
    name: "events-new"
  }, {
    path: "/profile/change-password",
    component: _dd055890,
    name: "profile-change-password"
  }, {
    path: "/profile/create",
    component: _ac63e0e8,
    name: "profile-create"
  }, {
    path: "/profile/notification-preferences",
    component: _5cf3b4a6,
    name: "profile-notification-preferences"
  }, {
    path: "/profile/request-access",
    component: _2376d1f2,
    name: "profile-request-access"
  }, {
    path: "/",
    component: _0547af50,
    name: "index"
  }, {
    path: "/events/admin/:uuid",
    component: _350edf51,
    name: "events-admin-uuid"
  }, {
    path: "/events/join/:uuid",
    component: _a9725c18,
    name: "events-join-uuid"
  }, {
    path: "/events/:slug/:uuid",
    component: _3a40ace8,
    name: "events-slug-uuid"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
